import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import DownloadIcon from '@mui/icons-material/Download'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Popover from '@mui/material/Popover'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { useTranslation } from 'react-i18next'
import ProposalDownloadButton from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/ProposalDownloadButton'
import ProposalDownloadPopoverDecisionAttachments from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/ProposalDownloadPopoverDecisionAttachments'
import { useVendorDecisionAttachmentsApi } from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/api/useVendorDecisionAttachmentsApi'

const ProposalDownloadPopover: React.FC<{ proposal: ProposalHistory }> = ({ proposal }) => {
  const { t } = useTranslation()
  const decisionAttachmentsToken = proposal.decisionAttachmentsContextToken

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [pendingOpen, setPendingOpen] = React.useState(false)

  const { data: decisionAttachments, isLoading: isDecisionLoading } = useVendorDecisionAttachmentsApi(
    pendingOpen ? decisionAttachmentsToken : undefined
  )

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setPendingOpen(true)
  }
  const handleClose = () => {
    setPendingOpen(false)
    setAnchorEl(null)
  }

  const waitingForAttachments = Boolean(decisionAttachmentsToken) && pendingOpen && isDecisionLoading
  const open = pendingOpen && Boolean(anchorEl) && !waitingForAttachments
  const id = open ? 'proposal-download-popover' : undefined

  return (
    <>
      <IconButton aria-label={t('download-proposal')} onClick={handleClick} disabled={waitingForAttachments}>
        {waitingForAttachments ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          <>
            <DownloadIcon color="primary" />
            <ArrowDropDownIcon color="primary" sx={{ ml: -0.75 }} />
          </>
        )}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Stack
          sx={{ display: 'flex', minWidth: '220px', maxWidth: '450px', alignItems: 'stretch' }}
          divider={<Divider orientation="horizontal" flexItem />}
        >
          <Box sx={{ py: 2, px: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
              <ProposalDownloadButton proposal={proposal} />
            </Box>
          </Box>
          {decisionAttachmentsToken && (decisionAttachments?.length ?? 0) > 0 && (
            <Box sx={{ display: 'flex', py: 2, px: 3 }}>
              <ProposalDownloadPopoverDecisionAttachments
                contextToken={decisionAttachmentsToken}
                attachments={decisionAttachments ?? []}
              />
            </Box>
          )}
        </Stack>
      </Popover>
    </>
  )
}

export default ProposalDownloadPopover
